import { Reveal } from "@/components/motion/Reveal";

export default function ComparisonTable({ headers, rows, highlightCol = 2 }) {
  return (
    <Reveal>
      <div className="w-full overflow-x-auto rounded-2xl border border-gray-200" data-testid="comparison-table">
        <table className="w-full text-left border-collapse min-w-[640px]">
          <thead>
            <tr>
              {headers.map((h, i) => (
                <th
                  key={i}
                  className={`py-5 px-6 text-xs font-bold uppercase tracking-[0.15em] border-b border-gray-200 ${
                    i === highlightCol ? "text-[#0B63F6] bg-[#0B63F6]/[0.04]" : "text-gray-500"
                  }`}
                >
                  {h}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, r) => (
              <tr key={r} className="hover:bg-gray-50/60 transition-colors">
                {row.map((cell, c) => (
                  <td
                    key={c}
                    className={`py-5 px-6 border-b border-gray-100 text-[15px] ${
                      c === 0 ? "font-semibold text-[#111111]" : c === highlightCol ? "text-[#111111] bg-[#0B63F6]/[0.03] font-medium" : "text-gray-600"
                    }`}
                  >
                    {cell}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Reveal>
  );
}
